import { Component } from '@angular/core';
import { PzService } from '../../service/pz.service';
import { GENERAL_ERROR_SUMMARY } from '../../utils/error-handler';
import { NotificationService } from '../../service/notification.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
})
export class SettingsComponent {
  public soundOn: boolean;
  public tamperMonkeyScript: string;
  public showTamperMonkeyScriptOverlay = false;
  public maxRounds: number;
  public startPlayer: string;
  public passwordPriceInputMode: boolean;

  private pathToTamperMonkeyScript = 'assets/js/hide-euro-prices.user.js';

  constructor(
    public pzService: PzService,
    private notificationService: NotificationService
  ) {
    this.soundOn = pzService.soundOn;
    this.maxRounds = pzService.maxRounds;
    this.startPlayer = `player${pzService.startPlayer}`;
    this.passwordPriceInputMode = pzService.passwordPriceInputMode;
  }

  public handleChangeSound(): void {
    this.pzService.soundOn = this.soundOn;
  }

  public handleChangeMaxRounds(): void {
    this.pzService.maxRounds = this.maxRounds;
  }

  public handleChangeStartPlayer(): void {
    this.pzService.startPlayer = parseInt(
      this.startPlayer.substring(this.startPlayer.length - 1),
      10
    );
  }

  public handleChangePricePasswordMode(): void {
    this.pzService.passwordPriceInputMode = this.passwordPriceInputMode;
  }

  public showTamperMonkeyScript(): void {
    fetch(this.pathToTamperMonkeyScript)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.text())
      .then((text) => {
        this.showTamperMonkeyScriptOverlay = true;
        this.tamperMonkeyScript = text;
      })
      .catch((err) => {
        console.error(
          `Could not fetch file "${this.pathToTamperMonkeyScript}".`,
          err
        );
        this.notificationService.showError(
          GENERAL_ERROR_SUMMARY,
          `Datei nicht gefunden`
        );
      });
  }
}
